export default __webpack_public_path__ + "static/media/plan.4ffd376c.jpg";